export enum Role {
	WeddingCouple 					= 1,
	ExperienceProvider 				= 2,
	Charity						 	= 3,
	Individual 						= 4,
	BBB 							= 5,
	CustomerSupport 				= 6,
	AlternateExperienceProvider 	= 7,
	Registerfinder					= 8
}